import HeroBg from "public/wiredAndWireless/network-wired&wire.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Compare Our Plans",
    link: "comparison",
  },
  button2: {
    label: "Design Your Network",
    link: "contact-us",
  },
  title: "Seamless, Secure, and Scalable Connectivity – Anywhere, Anytime",
  desc: "Delivering reliable, secure network connectivity with global reach and on-demand scalability for modern enterprises.",
  image: HeroBg,
};
